(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    class UnboundCartAddons extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.initialize();
    document.addEventListener('cart:update', () => requestAnimationFrame(() => { if (this.isConnected) this.initialize(); }), {signal: this.abort.signal});
    this.addEventListener('submit', event => this.add(event), {signal: this.abort.signal});
  }
  initialize() {
    this.choiceAbort?.abort();
    this.choiceAbort = new AbortController();
    this.querySelectorAll('[data-cart-addon]').forEach(form => {
      const variants = JSON.parse(form.dataset.variants);
      const color = form.querySelector('[data-addon-color]');
      const size = form.querySelector('[data-addon-size]');
      const colors = [...new Set(variants.filter(variant => variant.available).map(variant => variant.color))];
      const submit = form.querySelector('button[type="submit"]');
      const rank = value => {
        const ranks = {XXS:0,XS:1,S:2,SMALL:2,M:3,MEDIUM:3,L:4,LARGE:4,XL:5,XLARGE:5,XXL:6,'2XL':6,XXXL:7,'3XL':7,'4XL':8,'5XL':9,'6XL':10};
        const text = String(value || '').toUpperCase().replace(/\s/g,'');
        if(text in ranks) return ranks[text];
        const parts = text.split('/').map(part => ranks[part]);
        if(parts.length>1 && parts.every(Number.isFinite)) return parts.reduce((sum,value)=>sum+value,0)/parts.length;
        return /^\d+(\.\d+)?$/.test(text) ? Number(text) : NaN;
      };
      const nearest = (wanted,available) => {
        const target = rank(wanted);
        if(!Number.isFinite(target)) return available[0] || '';
        return [...available].sort((left,right) => {
          const leftRank = rank(left), rightRank = rank(right);
          const leftDistance = Number.isFinite(leftRank) ? Math.abs(leftRank-target) : Infinity;
          const rightDistance = Number.isFinite(rightRank) ? Math.abs(rightRank-target) : Infinity;
          return leftDistance-rightDistance || rightRank-leftRank;
        })[0] || '';
      };
      color.replaceChildren(...colors.map(value => new Option(value, value)));
      color.value = colors.includes(form.dataset.color) ? form.dataset.color : colors[0];
      let manuallySelectedSize = '';
      const update = (colorChanged = false) => {
        const matching = variants.filter(variant => variant.color === color.value);
        const available = matching.filter(variant => variant.available);
        if (size && colorChanged) {
          const wanted = manuallySelectedSize || form.dataset.preferredSize || size.value;
          const sizes = [...new Set(matching.map(variant => variant.size))];
          const availableSizes = [...new Set(available.map(variant => variant.size))];
          size.replaceChildren(...sizes.map(value => {
            const inStock = availableSizes.includes(value);
            const option = new Option(inStock ? value : value + ' — ' + this.dataset.soldOut, value);
            option.disabled = !inStock;
            return option;
          }));
          size.value = availableSizes.includes(wanted) ? wanted : nearest(wanted,availableSizes);
        }
        form.querySelectorAll('[data-addon-color-button]').forEach(choice => {
          choice.hidden = !colors.includes(choice.dataset.color);
          choice.setAttribute('aria-pressed', String(choice.dataset.color === color.value));
        });
        const variant = available.find(value => !size || value.size === size.value);
        const preview = variant || available[0];
        form.elements.id.value = variant?.id || '';
        submit.disabled = !variant;
        submit.textContent = !variant ? this.dataset.chooseSize : variant.saving ? this.dataset.addSaving.replace('__PERCENT__',variant.saving) : this.dataset.add;
        if (preview) {
          form.querySelector('.ub-cart-addon__price').textContent = preview.price;
          form.querySelector('.ub-cart-addon__color-name').textContent = color.value;
          const compare = form.querySelector('[data-addon-compare]');
          const saving = form.querySelector('[data-addon-save]');
          compare.hidden = !preview.saving; saving.hidden = !preview.saving;
          compare.textContent = preview.compare;
          saving.textContent = form.dataset.saving.replace('__PERCENT__', preview.saving).replace('__AMOUNT__', preview.saving_amount);
          const image = form.querySelector('.ub-cart-addon__image img');
          image.removeAttribute('srcset'); image.src = preview.image; image.alt = color.value;
        }
      };
      form.querySelectorAll('[data-addon-color-button]').forEach(choice => choice.addEventListener('click', () => {color.value = choice.dataset.color; update(true);}, {signal: this.choiceAbort.signal}));
      size?.addEventListener('change', () => {manuallySelectedSize=size.value;update();}, {signal: this.choiceAbort.signal});
      update(true);
    });
  }
  disconnectedCallback() { this.abort?.abort(); this.choiceAbort?.abort(); }
  async add(event) {
    const form = event.target.closest('[data-cart-addon]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button.disabled || !form.elements.id.value) return;
    const error = form.querySelector('[data-addon-error]');
    error.hidden = true; button.disabled = true; button.textContent = this.dataset.adding;
    try {
      const { CartUpdateEvent } = await import('@theme/events');
      const root = window.Shopify?.routes?.root || '/';
      const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(node => node.dataset.sectionId).filter(Boolean))].slice(0, 5);
      const response = await fetch(root + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: [{id: form.elements.id.value, quantity: 1}], sections, sections_url: window.location.pathname})});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || this.dataset.error);
      document.dispatchEvent(new CartUpdateEvent(data, 'unbound-cart-addons', {sections: data.sections, source: 'unbound-cart-addons'}));
    } catch (issue) { error.textContent = issue.message || this.dataset.error; error.hidden = false; }
    finally { const selected = JSON.parse(form.dataset.variants).find(value=>String(value.id)===form.elements.id.value); button.disabled = !selected?.available; button.textContent = selected?.saving ? this.dataset.addSaving.replace('__PERCENT__',selected.saving) : this.dataset.add; }
  }
}
if (!customElements.get('ub-cart-addons')) customElements.define('ub-cart-addons', UnboundCartAddons);
class UnboundCartSize extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.addEventListener('change', event => { if (event.target.matches('select')) this.change(event.target); }, {signal: this.abort.signal});
  }
  disconnectedCallback() { this.abort?.abort(); }
  async change(select) {
    if (select.disabled || select.value === this.dataset.currentId) return;
    const component = this.closest('cart-items-component');
    const error = this.querySelector('[data-size-error]');
    error.hidden = true; select.disabled = true; component.classList.add('cart-items-disabled');
    try {
      const { CartUpdateEvent } = await import('@theme/events');
      const root = window.Shopify?.routes?.root || '/';
      const currentResponse = await fetch(root + 'cart.js');
      if (!currentResponse.ok) throw new Error(this.dataset.error);
      const current = await currentResponse.json();
      const previous = current.items.find(item => item.key === this.dataset.key);
      if (!previous) throw new Error(this.dataset.error);
      const existing = current.items.find(item => String(item.variant_id) === select.value && !item.selling_plan_allocation && Object.keys(item.properties || {}).length === 0);
      const updates = {[previous.key]: 0, [select.value]: previous.quantity + (existing?.quantity || 0)};
      const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(node => node.dataset.sectionId).filter(Boolean))].slice(0, 5);
      const response = await fetch(root + 'cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({updates, sections, sections_url: window.location.pathname})});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || this.dataset.error);
      document.dispatchEvent(new CartUpdateEvent(data, 'unbound-cart-size', {itemCount: data.item_count, sections: data.sections, source: 'unbound-cart-size'}));
    } catch (issue) { select.value = this.dataset.currentId; error.textContent = issue.message || this.dataset.error; error.hidden = false; }
    finally { select.disabled = false; component.classList.remove('cart-items-disabled'); }
  }
}
if (!customElements.get('ub-cart-size')) customElements.define('ub-cart-size', UnboundCartSize);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('unbound-menu-promos')) { customElements.define('unbound-menu-promos', class extends HTMLElement { connectedCallback() { if(this.timer) clearInterval(this.timer); if(!this.ready) { this.ready=true; const track=this.querySelector('.ub-menu-promos-track'); const dots=[...this.querySelectorAll('[data-slide]')]; this.current=0; this.go=index=>{this.current=(index+dots.length)%dots.length;track.scrollTo({left:this.current*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};this.addEventListener('click',event=>{const button=event.target.closest('button');if(!button)return;if(button.dataset.slide!==undefined)this.go(Number(button.dataset.slide));if(button.dataset.direction)this.go(this.current+Number(button.dataset.direction));});track.addEventListener('scroll',()=>{this.current=Math.round(track.scrollLeft/track.clientWidth);dots.forEach((dot,index)=>index===this.current?dot.setAttribute('aria-current','true'):dot.removeAttribute('aria-current'));},{passive:true});track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.go(this.current+(event.key==='ArrowRight'?1:-1));}}); } this.timer=setInterval(()=>{if(!document.hidden&&!matchMedia('(prefers-reduced-motion: reduce)').matches&&this.closest('details')?.open)this.go(this.current+1);},2500); } disconnectedCallback(){clearInterval(this.timer);this.timer=null;} }); }

if (!customElements.get('unbound-menu-footer')) {
  customElements.define('unbound-menu-footer', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.details = this.closest('header-drawer')?.querySelector(':scope > details');
      this.stale = false;
      this.setupCountry(signal);
      document.addEventListener('cart:update', (event) => {
        const cart = event.detail?.resource;
        if (Number.isFinite(cart?.item_count) && Array.isArray(cart?.items)) {
          this.render(cart);
          this.stale = false;
        } else {
          this.stale = true;
          if (this.details?.open) this.refresh();
        }
      }, { signal });
      this.details?.addEventListener('toggle', () => { if (this.details.open && this.stale) this.refresh(); }, { signal });
      window.addEventListener('pageshow', (event) => { if (event.persisted) { this.stale = true; if (this.details?.open) this.refresh(); } }, { signal });
      this.querySelector('[data-menu-cart]')?.addEventListener('click', (event) => {
        const cartDrawer = document.querySelector('cart-drawer-component');
        const headerDrawer = this.closest('header-drawer');
        if (typeof cartDrawer?.open !== 'function' || !headerDrawer) return;
        event.preventDefault();
        const openCart = () => {
          if (this.details.open) return;
          this.details.removeEventListener('toggle', openCart);
          requestAnimationFrame(() => cartDrawer.open());
        };
        this.details.addEventListener('toggle', openCart, { signal });
        headerDrawer.close();
      }, { signal });
    }
    setupCountry(signal) {
      const region = this.querySelector('[data-menu-delivery]');
      const select = region?.querySelector('[data-menu-country]');
      if (!select) return;
      const renderCountry = code => {
        const option = Array.from(select.options).find(option => option.value === code);
        if (!option) return;
        select.value = code;
        region.querySelector('[data-country-name]').textContent = option.dataset.label;
        const flag = region.querySelector('[data-country-flag] img');
        flag.removeAttribute('srcset');
        flag.src = option.dataset.flag;
      };
      select.addEventListener('change', () => {
        try { localStorage.setItem('unbound-delivery-country', select.value); } catch {}
        renderCountry(select.value);
        select.form.requestSubmit();
      }, { signal });
      let preferred;
      try { preferred = localStorage.getItem('unbound-delivery-country'); } catch {}
      if (preferred) { renderCountry(preferred); return; }
      const detect = async () => {
        if (!this.details?.open || this.countryRequested) return;
        this.countryRequested = true;
        try {
          const response = await fetch(region.dataset.detectionUrl, { signal, headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const data = await response.json();
          renderCountry(data.detected_values?.country?.handle);
        } catch {}
      };
      this.details?.addEventListener('toggle', detect, { signal });
      detect();
    }
    disconnectedCallback() { this.controller?.abort(); }
    async refresh() {
      if (this.pending) return;
      this.pending = true;
      try {
        const response = await fetch(this.dataset.cartUrl, { headers: { Accept: 'application/json' }, signal: this.controller.signal });
        if (!response.ok) throw new Error('Cart unavailable');
        this.render(await response.json());
        this.stale = false;
      } catch {} finally { this.pending = false; }
    }
    render(cart) {
      const count = Number(cart.item_count) || 0;
      this.querySelector('[data-menu-cart-count]').textContent = count === 1 ? this.dataset.one : this.dataset.many.replace('__count__', count);
      const image = this.querySelector('[data-menu-cart-image]');
      const source = cart.items?.[0]?.featured_image?.url || cart.items?.[0]?.image;
      image.hidden = !source;
      this.querySelector('[data-menu-cart-icon]').hidden = Boolean(source);
      if (source) {
        const url = new URL(source, location.origin);
        url.searchParams.set('width', '96');
        if (image.src !== url.href) image.src = url.href;
      } else image.removeAttribute('src');
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-badges"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ub-card-offer')) {
  customElements.define('ub-card-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mounted) return;
      requestAnimationFrame(() => {
        if (!this.isConnected || this.dataset.mounted) return;
        const card = this.closest('product-card, .ub-plus-colour-card, .ub-category-colour-card, .resource-card');
        const media = card?.querySelector('.card-gallery, .ub-plus-colour-card__media, .ub-category-colour-card__media, .resource-card__media');
        if (!media) return;
        this.dataset.mounted = 'true';
        media.classList.add('ub-offer-media');
        media.after(this);
        this.hidden = false;
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["unbound-wishlist"] && !Shopify.designMode) return;
  try {
    (() => {
    const key = 'unbound-wishlist-v1';
    const eventName = 'unbound:wishlist-change';
    const read = () => {
      try {
        const items = JSON.parse(localStorage.getItem(key) || '[]');
        return Array.isArray(items) ? items.filter(item => item && typeof item.id === 'string' && typeof item.title === 'string' && typeof item.url === 'string' && item.url.startsWith('/products/')).slice(0, 100) : [];
      } catch { return []; }
    };
    const save = items => {
      try { localStorage.setItem(key, JSON.stringify(items)); document.dispatchEvent(new Event(eventName)); return true; }
      catch { return false; }
    };
    class WishlistHeart extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.sync = () => {
          const active = read().some(item => item.id === this.dataset.id);
          this.button.setAttribute('aria-pressed', String(active));
          this.button.setAttribute('aria-label', `${active ? this.dataset.remove : this.dataset.save}: ${this.dataset.title}`);
        };
        this.toggle = event => {
          event.preventDefault();event.stopPropagation();
          const items = read();
          const active = items.some(item => item.id === this.dataset.id);
          const next = active ? items.filter(item => item.id !== this.dataset.id) : [...items, { id:this.dataset.id, title:this.dataset.title, url:this.dataset.url, image:this.dataset.image }];
          if (!save(next.slice(-100))) this.querySelector('[role="status"]').textContent = this.dataset.error;
        };
        this.button.addEventListener('click', this.toggle);
        document.addEventListener(eventName, this.sync);window.addEventListener('storage', this.sync);this.sync();
      }
      disconnectedCallback() { this.button.removeEventListener('click',this.toggle);document.removeEventListener(eventName,this.sync);window.removeEventListener('storage',this.sync); }
    }
    class WishlistList extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.openButton = this.querySelector('.ub-wishlist-open');
        this.open = () => { this.sync();this.dialog.showModal(); };
        this.close = () => this.dialog.close();
        this.outside = event => { if (event.target === this.dialog) { const r = this.dialog.getBoundingClientRect();if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.close(); } };
        this.sync = () => {
          const items = read();this.querySelector('[data-count]').textContent = items.length;
          const list = this.querySelector('[data-items]');list.replaceChildren();
          if (!items.length) { const empty = document.createElement('p');empty.textContent = this.dataset.empty;list.append(empty); }
          items.forEach(item => {
            const row = document.createElement('div');row.className = 'ub-wishlist-item';
            const image = document.createElement('img');image.alt = item.title;image.loading = 'lazy';
            try { const src = new URL(item.image, location.origin);if (src.protocol === 'https:') image.src = src.href; } catch {}
            const body = document.createElement('div');const link = document.createElement('a');link.href = item.url;link.textContent = item.title;
            const remove = document.createElement('button');remove.type = 'button';remove.textContent = this.dataset.remove;remove.setAttribute('aria-label', `${this.dataset.remove}: ${item.title}`);
            remove.addEventListener('click', () => { if (!save(read().filter(saved => saved.id !== item.id))) this.querySelector('[data-status]').textContent = this.dataset.error; });
            body.append(link,remove);row.append(image,body);list.append(row);
          });
        };
        this.openButton.addEventListener('click',this.open);this.querySelector('[data-close]').addEventListener('click',this.close);this.dialog.addEventListener('click',this.outside);
        document.addEventListener(eventName,this.sync);window.addEventListener('storage',this.sync);this.sync();
      }
      disconnectedCallback() { this.openButton.removeEventListener('click',this.open);this.querySelector('[data-close]').removeEventListener('click',this.close);this.dialog.removeEventListener('click',this.outside);document.removeEventListener(eventName,this.sync);window.removeEventListener('storage',this.sync); }
    }
    if (!customElements.get('ub-wishlist')) customElements.define('ub-wishlist',WishlistHeart);
    if (!customElements.get('ub-wishlist-list')) customElements.define('ub-wishlist-list',WishlistList);
  })();
  } catch(e) { console.error(e); }
})();

})();
